import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewsGrpComponent } from './grp_module/news-grp/news-grp.component';
import { CategoryGrpComponent } from './grp_module/category-grp/category-grp.component';
import { MarkerGrpComponent } from './grp_module/marker-grp/marker-grp.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'news', pathMatch: 'full' }, // Default redirect to news
      { path: 'news', component: NewsGrpComponent },
      { path: 'category', component: CategoryGrpComponent },
      { path: 'marker', component: MarkerGrpComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GrpRoutingModule {}
